import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { ErrorPageStateComponent } from "./modules/shared/components/error/error-page-state.component";
import { canActivateInstance } from "./utils/authGuard.utils";
import { PublicSearchComponent } from "./pages/public-search/public-search.component";
import { AdminComponent } from './pages/admin/admin.component';
import { InstanceExistsGuard } from './utils/instance-exists.guard';

const routes: Routes = [
  {
    path: '', children: [
      { path: '', redirectTo: 'error', pathMatch: 'full' },
      {
        path: 'admin',
        component: AdminComponent,
        canActivate: [OktaAuthGuard, canActivateInstance],
        data: { breadcrumb: { label: 'Admin' } },
        loadChildren: () => import('./pages/admin/admin.routing').then(m => m.AdminRoutes)
      },
      { path: 'callback', component: OktaCallbackComponent },
      {
        path: 'error',
        pathMatch: 'full',
        component: ErrorPageStateComponent
      },
      {
        path: ':alias',
        canActivate: [InstanceExistsGuard],
        children: [
          {
            path: '',
            pathMatch: 'full',
            loadComponent: () => import('./pages/public-landing/public-landing.component').then(m => m.PublicLandingComponent)
          },
          {
            path: 'search',
            component: PublicSearchComponent
          },
          {
            path: 'report',
            loadComponent: () => import('./pages/public-report/public-report.component').then(m => m.PublicReportComponent)
          }
        ]
      }
    ]
  },
  { path: '**', redirectTo: 'error' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}